module.exports = __webpack_public_path__ + "img/city-profile.cacb451d.jpg";